// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__UqRFB","dotLoader":"styles_dotLoader__EEfMe","grow":"styles_grow__l0l+l"};